export const APPROVE_PENDING_BEGIN = "APPROVE_PENDING_BEGIN",
APPROVE_PENDING_SUCCESS = "APPROVE_PENDING_SUCCESS",
APPROVE_PENDING_ERROR = "APPROVE_PENDING_ERROR",
SET_MEMBER_ACTIVITY = "SET_MEMBER_ACTIVITY";